export default {
    type: 'people',
    aliases: {
        camel: 'people',
        singular: 'Person',
        plural: 'People',
        lowerSingular: 'people',
        lowerPlural: 'people',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'person-modules',
                localKey: 'personId',
                foreignKey: 'moduleId'
            }
        },
        'specialisations': {
            adminLabel: "Specialisations",
            pivot: {
                type: 'person-specialisations',
                localKey: 'personId',
                foreignKey: 'specialisationId'
            }
        },
        'departments': {
            adminLabel: "Departments",
            pivot: {
                type: 'person-departments',
                localKey: 'personId',
                foreignKey: 'departmentId'
            }
        },
    },
    publishable: true,
    adminSection: 'about',
    componentType: 'base',
    searchOn: ['firstName', 'lastName'],
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPersonCollection',
            loader: () => import('./AdministerPersonCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerPersonRecord',
            loader: () => import('./AdministerPersonRecord')
        },
        webRecord: {
            name: 'DisplayPersonRecord',
            loader: () => import('./DisplayPersonRecord')
        },
        webCollectionItem: {
            name: 'PersonPoster',
            loader: () => import('./PersonPoster')
        }
    },
};
